import React from 'react';
import PropTypes from 'prop-types';

/**
 * SearchKishuNameSummary
 */
class SearchKishuNameSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSuggestions: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.renderSuggestions = this.renderSuggestions.bind(this);
    this.renderButton = this.renderButton.bind(this);
  }

  handleChange(event) {
    const value = event.target.value;
    this.setState({
      showSuggestions: value.length > 0,
      kishu: value,
    });
    this.props.data.kishu = value;
    this.props.actions.stopUpdate();
  }

  handleSelect(item) {
    this.setState({
      showSuggestions: false,
      kishu: item.display_name,
    });
    this.props.data.kishu = item.display_name;
    this.props.actions.clickSearchSummary();
  }

  handleClear() {
    this.setState({
      showSuggestions: false,
      kishu: '',
    });
    this.props.actions.clickClearSummary();
  }

  handleSearch() {
    this.props.actions.clickSearchSummary();
  }

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      this.setState({ showSuggestions: false });
      this.props.actions.clickSearchSummary();
      event.preventDefault();
    }
  }

  renderSuggestions() {
    const { kishuNameList } = this.props.data.itemList;

    if (!this.state.showSuggestions || !kishuNameList || !kishuNameList.data) return null;

    const filtered = kishuNameList.data.filter(item =>
      item.display_name.toLowerCase().includes(this.props.data.kishu.toLowerCase())
    );

    if (filtered.length === 0) return null;

    return (
      <ul className="suggestions">
        {filtered.map(item => (
          <li key={item.id} onClick={() => this.handleSelect(item)}>
            {item.display_name}
          </li>
        ))}
      </ul>
    );
  }

  renderButton() {
    if (this.props.data.kishu !== '') {
      return (
        <a onClick={this.handleClear}>
          <i id="question" className="clear quetion_summary" />
        </a>
      );
    } else {
      return (
        <a onClick={this.handleSearch}>
          <i id="question" className="search quetion_summary" />
        </a>
      );
    }
  }

  render() {
    return (
      <div className="search_kishu_name_summary_top">
        {/* サジェスト表示中にクリックブロック用の透明レイヤーを表示 */}
        {this.state.showSuggestions && (
          <div
            className="click-blocker"
            onClick={() => this.setState({ showSuggestions: false })}
          />
        )}

        {/* 検索入力欄とサジェスト本体 */}
        <div className="input_search content_item_border_default" >
          <input
            type="text"
            id="search"
            className="kishu_name_search"
            maxLength="128"
            value={this.props.data.kishu}
            placeholder="検索する機種名を入力"
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            onFocus={this.props.actions.stopUpdate}
            autoComplete="off"
          />
          {this.renderButton()}
          {this.renderSuggestions()}
        </div>
      </div>
    );
  }
}

SearchKishuNameSummary.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SearchKishuNameSummary;
